import { RemoteGetMapActivitiesMarkers } from 'data/usecases/dashboard';
import { GetMapActivitiesMarkers } from 'domain/usecases/dashboard';
import { makeApiUrlMapActivitiesMarkers } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetMapActivitiesMarkers = (): GetMapActivitiesMarkers =>
  new RemoteGetMapActivitiesMarkers(
    makeApiUrlMapActivitiesMarkers(),
    makeAxiosHttpClient(),
  );
